













































































































































































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BFormCheckbox,
  BPagination,
  BRow,
  BTable,
  BBadge,
  BAlert,
  BFormDatepicker,
  BFormGroup
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { ShortOpportunite } from "@/api/models/opportunites/opportunite";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import ViewAdvancedContrat from '@/views/adherents/advancedContrats/ViewAdvancedContrat.vue'
import SearchableVueSelect from '@/components/selects/SearchableVueSelect.vue'
import { UserDetail } from "@/api/models/authorization/userDetails/userDetail";
import { DetailsUtilisateur, ShortUtilisateur } from "@/api/models/utilisateurs/utilisateur";
import { ShortAdvancedContrat } from "@/api/models/contrats/advancedContrat";

@Component({
  components: {
    BCard,
    BAlert,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormCheckbox,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    BBadge,
    BFormDatepicker,
    BFormGroup,
    ViewAdvancedContrat,
    SearchableVueSelect
  },
})
export default class ListAdvancedContrats extends Vue {
  perPage = 25;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  timeout: any = null;
  searchQuery = "";
  isSortDirDesc = false;
  sortBy = "nom";

  isViewAdvancedContratModalActive = false
  selectedAdvancedContratId = ''

  filterResponsableId: string | null = null
  filterTypeContrat: string | null = null
  filterTypePrestation: string | null = null
  filterDateDebutAvant: string | null = null
  filterDateDebutApres: string | null = null
  filterDateFinAvant: string | null = null
  filterDateFinApres: string | null = null

  listStatuts: { code: string; libelle: string; }[] = [];
  listNatureOffres: { code: string; libelle: string; }[] = [];
  listTypesPrestation: { code: string; libelle: string; }[] = [];
  paginatedListResponsables = new PaginatedList<DetailsUtilisateur>()
  listTypeContrat = [];

  tableColumns = [
    { key: "entrepriseLibelle", label:"Entreprise", sortable: true },
    { key: "nom", sortable: true },
    { key: "typeContrat", label: "Type de contrat", sortable: true },
    { key: "responsableCompleteNom", label: "Responsable", sortable: true },
    { key: "typePrestation", label: "Type de prestation", sortable: true },
    { key: "montant", sortable: true },
    { key: "dateDemarrage", label: "Date de démarrage", sortable: true },
    { key: "dateExpiration", label: "Date d'expiration", sortable: true }
  ];
  paginatedListAdvancedContrats = new PaginatedList<ShortAdvancedContrat>();

  async created() {
    await this.loadStatuts();
    await this.loadNatureOffres();
    await this.loadTypesPrestation();
    await this.getTypeContrat();

    await this.loadListAdvancedContrats({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery,
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListAdvancedContrats.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListAdvancedContrats.items.length
    );
  }

  getLibelleFromCode(code: string | undefined, list: {code: string, libelle: string}[]): string {
    if (!code) return '-'
    const item = list.find(i => i.code === code)
    return item ? item.libelle : code
  }

  async loadStatuts() {
    this.listStatuts = await this.loadParametre('opportunites_statut')
  }

  async loadNatureOffres() {
    this.listNatureOffres = await this.loadParametre('opportunites_nature_offre')
  }

  async loadTypesPrestation() {
    this.listTypesPrestation = await this.loadParametre('opportunites_type_prestation')
  }

  async loadResponsables(params: any) {
    await this.$http.myressif.utilisateurs
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.search ?? "",
        params?.hiddenUser ?? false,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
        null,
        null,
        true
      )
      .then((response: PaginatedList<DetailsUtilisateur>) => {
        this.paginatedListResponsables.items = this.paginatedListResponsables!.items.concat(
          response.items.filter(
            (ri) => !this.paginatedListResponsables!.items.some((lsi) => lsi.id == ri.id)
          )
        ).map((x: ShortUtilisateur) => <DetailsUtilisateur>{
          ...x,
          completeLabel: `${x.nom} ${x.prenom}`
        });
        this.paginatedListResponsables.hasNextPage = response.hasNextPage
        this.paginatedListResponsables.totalCount = response.totalCount
      })
  }

  async getTypeContrat() {
    try {
      const res: any = await this.$http.myressif.parametres.getByNom("type_advanced_contrat_adherent");
      this.listTypeContrat = res ? JSON.parse(res.valeur) : [];
    } catch (error: any) {
      errorAlert.fire({
        text: error?.response?.data?.detail ?? error.message,
      });
    }
  }

  async loadParametre(parametre: string): Promise<{code: string, libelle: string}[]> {
    var response: {code: string, libelle: string}[] = []
    await this.$http.myressif.parametres
      .getByNom(parametre)
      .then((res: {valeur: string}) => {
        response = res ? JSON.parse(res.valeur) : [];
      }),
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      };

      return response;
  }

  @Watch("currentPage")
  @Watch("perPage")
  async paginationChanged() {
    await this.loadListAdvancedContrats({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery,
    });
  }

  @Watch('searchQuery')
  @Watch("filterTypePrestation")
  @Watch("filterResponsableId")
  @Watch("filterTypeContrat")
  @Watch("filterDateDebutApres")
  @Watch("filterDateDebutAvant")
  @Watch("filterDateFinApres")
  @Watch("filterDateFinAvant")
  async searchOpportunite() {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListAdvancedContrats({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        orderBy: this.sortBy,
        orderByDescending: this.isSortDirDesc,
        search: this.searchQuery,
      })
    }, 1000);
  }

  updateSort(params: any) {
    this.sortBy = params.sortBy;
    params = {
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      orderBy: this.sortBy,
      orderByDescending: this.isSortDirDesc
    };
    this.isSortDirDesc = !this.isSortDirDesc;
    this.loadListAdvancedContrats(params);
  }

  async loadListAdvancedContrats(params: any) {
    if (!params || params?.reset) {
      this.paginatedListAdvancedContrats = new PaginatedList<ShortAdvancedContrat>();
    }

    await this.$http.myressif.advancedContrats
      .paginatedList(
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy,
        params?.orderByDescending,
        params?.search ?? "",
        this.filterTypePrestation,
        this.filterResponsableId,
        this.filterTypeContrat,
        this.filterDateDebutApres,
        this.filterDateDebutAvant,
        this.filterDateFinApres,
        this.filterDateFinAvant
      )
      .then((response: PaginatedList<ShortAdvancedContrat>) => {
        this.paginatedListAdvancedContrats = response;
      });
  }

  onRowSelected(record: ShortAdvancedContrat) {
    this.selectedAdvancedContratId = record.id
    this.isViewAdvancedContratModalActive = true
  }

  async reloadList() {
    await this.loadListAdvancedContrats({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery,
      orderBy: this.sortBy,
      orderByDescending: this.isSortDirDesc
    })
  }
}
